import dayjs from 'dayjs';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import isoWeek from 'dayjs/plugin/isoWeek';
import utc from 'dayjs/plugin/utc';

import 'dayjs/locale/de';

dayjs.extend(advancedFormat);
dayjs.extend(utc);
dayjs.extend(isoWeek);

export { dayjs };
